import { c as _c } from "react/compiler-runtime";
import { DELEGATION_CONTRACT } from "@/constants/constants";
import { useEnsName } from "wagmi";
export function useOrignalDelegatorEnsResolution(props) {
  const $ = _c(2);
  const t0 = props.subdelegation ? props.subdelegation.originalDelegator as `0x${string}` : undefined;
  let t1;
  if ($[0] !== t0) {
    t1 = {
      address: t0,
      chainId: 1
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return useEnsName(t1);
}
const DELEGATION_NETWORK_ERROR = `Switch to ${DELEGATION_CONTRACT.chain_id === 1 ? "Ethereum Mainnet" : "Sepolia Network"}`;
const DELEGATION_LOCKED_ERROR = "CANNOT ESTIMATE GAS - This can be caused by locked collections/use-cases";
export function getGasError(error: any) {
  if (error.message.includes("Chain mismatch")) {
    return DELEGATION_NETWORK_ERROR;
  } else {
    return DELEGATION_LOCKED_ERROR;
  }
}